import CryptoJS from "crypto-js";

export function encryptMessage(message, secretKey) {
    const cypherText = CryptoJS.AES.encrypt(
        message,
        secretKey
    ).toString();

    return encodeURIComponent(cypherText);
}

export function decryptMessage(ciphertext, secretKey) {
    const ciphertextDecoded = decodeURIComponent(ciphertext);
    let wordArray = CryptoJS.AES.decrypt(
        ciphertextDecoded,
        secretKey
    );

    // If not properly decrypted then try again.
    if (wordArray == null || wordArray == undefined || wordArray.sigBytes == 0) {
        wordArray = CryptoJS.AES.decrypt(ciphertextDecoded, secretKey);
    }

    return wordArray.toString(CryptoJS.enc.Utf8);
}